export enum AuthenticatedRoutes {
  Dashboard = '/dashboard',
  Planner = '/planner',
  TimeTracking = '/time-tracking',
  TimeOff = '/time-off',
  TimeOffApprovals = '/time-off/approvals',
  TimeOffRequestCreate = '/time-off/new',
  TimeOffApprovalDetails = '/time-off/approvals/:requestId',
  TimeOffRequestDetails = '/time-off/:requestId',
  Team = '/team',
  TeamAddMember = '/team/new',
  TeamMemberDetails = '/team/:memberId',
  TeamMemberChangeEdit = '/team/:memberId/changes/:changeId',
  TeamMemberTimeOffRequestDetails = '/team/:memberId/time-off/:requestId',
  Projects = '/projects',
  AddProject = '/projects/new',
  ProjectDetails = '/projects/:projectId',
  ProjectChangeEdit = '/projects/:projectId/changes/:changeId',
  Clients = '/clients',
  AddClient = '/clients/new',
  ClientDetails = '/clients/:clientId',
  Invoices = '/invoices',
  GenerateInvoices = '/invoices/new',
  InvoiceDetails = '/invoices/:invoiceId',
  Bills = '/bills',
  BillDetails = '/bills/:billId',
  GenerateBills = '/bills/new',
  Overheads = '/overheads',
  Settings = '/settings',
  Reports = '/reports',
  ReportDetails = '/reports/:reportId',
  DataReconciliation = '/data-reconciliation',
  OnboardingIntegrationsOAuthCallback = '/onboarding/integrations/oauth/callback',
  TimeTrackingApprovals = '/time-tracking-approvals',
  Forbidden = '/forbidden',
  BillingExpired = '/billing/expired',
}

export enum DataReconciliationRoutes {
  Team = '/data-reconciliation/team',
  Clients = '/data-reconciliation/clients',
  Projects = '/data-reconciliation/projects',
}

export enum SettingsRoutes {
  ProfileInfo = '/settings/profile-info',
  Password = '/settings/password',
  Departments = '/settings/departments',
  Seniorities = '/settings/seniorities',
  Roles = '/settings/roles',
  General = '/settings/general',
  Finance = '/settings/finance',
  TimeOff = '/settings/time-off',
  TimeOffDetails = '/settings/time-off-type/:typeId',
  Integrations = '/settings/integrations',
  API = '/settings/api',
  CustomAttributes = '/settings/custom-attributes',
  Tags = '/settings/tags',
  Members = '/settings/members',
  Permissions = '/settings/permissions',
  DebugNotifications = '/settings/debug-notifications',
  FramerMockups = '/settings/framer-mockups',
}

export enum OnboardingRoutes {
  OnboardingOrganization = '/onboarding/organization',
  OnboardingIntegrations = '/onboarding/integrations',
  OnboardingTeam = '/onboarding/team',
  OnboardingClients = '/onboarding/clients',
  OnboardingProjects = '/onboarding/projects',
  OnboardingCompletion = '/onboarding/completion',
  OnboardingError = '/onboarding/error',
}

export enum UnauthenticatedRoutes {
  ActivateAccount = '/activate-account',
  Login = '/login',
  ResetPassword = '/reset-password',
  Register = '/register',
}

export enum CommonRoutes {
  TermsOfService = '/terms-of-service',
  PrivacyPolicy = '/privacy-policy',
}

export type Routes =
  | AuthenticatedRoutes
  | UnauthenticatedRoutes
  | CommonRoutes
  | OnboardingRoutes
  | SettingsRoutes
  | DataReconciliationRoutes;
